import Vue from 'vue'
let baseUrl = process.env.VUE_APP_API_IDP_URL;
if(baseUrl.substring(baseUrl.length - 1) == "/")
    baseUrl = baseUrl.substring(0, baseUrl.length - 1);

baseUrl = `${baseUrl}/user`;
export default{
    async listById(id){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/${encodeURI(id)}`);
    },
    async listMenu(){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/menu`);
    },
    async hasAccess(objectUniqueCode, privilegeUniqueCode){
        return await Vue.prototype.$httpJson.get(`${baseUrl}/has-access/${encodeURI(objectUniqueCode)}/${encodeURI(privilegeUniqueCode)}`);
    }      
}